import { filterMap } from '../../utils/filterMap';
import { StepWithLifecycleEffectsWithId } from '../../../use-cases/tour/tours/NewFeatureTour';

export const getTourIds = (steps: Array<StepWithLifecycleEffectsWithId>): string[] => {
  return filterMap(steps, step => step.id);
};
